import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUserSquare = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4" />
  </SvgIcon>
);

export default IconUserSquare;



// WEBPACK FOOTER //
// ./src/components/icons/IconUserSquare.js